<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>大量作業進度</h3>
          <hr />
        </div>
      </div>
    </div>
    <el-table :data="downloadData">
      <el-table-column label="執行項目" prop="topic"></el-table-column>
      <el-table-column label="類型" prop="type"></el-table-column>
      <el-table-column label="狀態" prop="status"></el-table-column>
      <el-table-column label="執行時間" prop="execDate"></el-table-column>
      <el-table-column label="開始時間" prop="startDate"></el-table-column>
      <el-table-column label="完成時間" prop="endDate"></el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <a v-if="scope.row.status !== '下載中'" :href="scope.row.url">
            <el-button type="success" plain native-type="button">
              下載
            </el-button>
          </a>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from 'axios'
import { cookies } from '@/utils/cookies'

export default {
  data() {
    return {
      downloadData: [],
    }
  },
  methods: {
    async fetchTableData() {
      let url = ''
      const token = cookies.get('user')
      if (location.href.includes('localhost')) {
        url = 'https://staging.download.gladmobile.com/web/api/excel/status'
      } else if (location.href.includes('staging.backstage.gladmobile.com')) {
        url = 'https://staging.download.gladmobile.com/web/api/excel/status'
      } else if (location.href.includes('backstage.gladmobile.com')) {
        console.log('backstage')
        url = 'https://download.gladmobile.com/web/api/excel/status'
      }
      await axios
        .get(`${url}`, { headers: { 'x-access-token': token } })
        .then((res) => {
          this.downloadData = res.data.result
          this.numberToStatus(this.downloadData)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    numberToStatus(downloadData) {
      const status = { 0: '下載中', 1: '已完成', 2: '失敗', 3: '已刪除' }
      // const type = { 0: "訂單"}
      return downloadData.map((obj) => {
        obj.status = status[obj.status]
        obj.type = status[obj.type]
        obj.endDate = this.utcTolocal(obj.endDate)
        obj.execDate = this.utcTolocal(obj.execDate)
        obj.startDate = this.utcTolocal(obj.startDate)
      })
    },
    utcTolocal(utcDate) {
      const date = new Date(utcDate)
      return date.toLocaleString()
    },
  },
  mounted() {
    this.fetchTableData()
  },
}
</script>

<style scope>
html {
  overflow-y: scroll;
}
.container {
  padding: 10px 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/download/WorkingStatus.vue